import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  paper: {
    borderRadius: "8px",
    backgroundColor: theme.palette.common.white,
    width: "35vw",
    outline: "none !important",
    "&:focus": {
      outline: "none !important",
    },
  },
  header: {
    padding: `${theme.spacing(3)}px 0 0 ${theme.spacing(3)}px`,
  },
  editButton: {
    padding: theme.spacing(1),
    color: "rgba(0, 0, 0, 0.4)",
  },
}));
